import { Box, Button, Grid, Link, Typography } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import useExceptionStyles from "./styles";
import { ROUTES } from "router/types";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { changeValue } from "store/SellerOnboarding/sellerOnboarding.slice";
import I18nKey from "../../translations/I18nKey";
import { useIntl } from "react-intl";
export const ErrorSellers = () => {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const errorParams = url.searchParams.get("error_message") || "Error";
  const classes = useExceptionStyles();
  const dispatch = useDispatch();
  const intl = useIntl();
  return (
    <>
      <Grid
        container
        rowSpacing={2}
        sx={{ padding: "40px", justifyContent: "center" }}
      >
        <Grid item xs={10}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <CancelIcon style={{ color: "red", fontSize: "34px" }} />
            <Typography style={{ color: "red" }}>{errorParams}</Typography>
          </Box>
        </Grid>
        <Grid item xs={10}>
          <Box className={classes.buttonsContainer}>
            <Button
              variant="outlined"
              size="small"
              className={classes.amazonAccount}
              onClick={() => {
                dispatch(changeValue(2));
                window.location.href = ROUTES.Sellers;
              }}
            >
              {intl.formatMessage({
                id: I18nKey.AMAZON_ACCOUNT,
              })}
            </Button>
            <Button
              variant="outlined"
              size="small"
              className={classes.amazonAccount}
            >
              {intl.formatMessage({
                id: I18nKey.AD_ACCOUNT,
              })}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
